import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../custom-button/custom-button.component";

@Component({
  selector: 'app-edit-cancel-button',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, CustomButtonComponent],
  templateUrl: './edit-cancel-button.component.html',
  styleUrl: './edit-cancel-button.component.css'
})
export class EditCancelButtonComponent {
  @Input() isEditing = false;
  @Input() disabled = false;
  @Input() isSaving = false;  

  @Output() edit = new EventEmitter<void>();
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  handleEdit() { if (!this.disabled) this.edit.emit(); }
  handleSave() { if (!this.disabled && !this.isSaving) this.save.emit(); }
  handleCancel() { if (!this.disabled && !this.isSaving) this.cancel.emit(); }
}
